import Img from "react-cool-img";

const component = props => {
	const {
		lazy = true,
		src,
		alt = "",
		placeholder = "",
		className,
		onClick
	} = props;

	return (
		<Img
			alt         = { alt }
			className   = { className }
			lazy        = { lazy }
			onClick     = { onClick }
			placeholder = { placeholder }
			src         = { src }
			width       = "100%"
		/>
	);
};

export default component;
